import api from "./api";

export default class SharingApi {
  static async get(data) {
    return await api.get(`excellences`, data);
  }
}
